export const COMPANY = {
  name: "Moruya Travel Solutions FZE",
  shortName: "Moruya",
  shortNameFull: "Moruya Travel Solutions",
  tagline: "The Dubai group behind our online travel platforms.",
  logo: "/moruya-logo.png",
  logoLight: "/moruya-logo-light.png",
  address: {
    line1: "Level 27, Unit 2705, Marina Plaza",
    city: "Dubai",
    country: "United Arab Emirates",
  },
  addressFull:
    "Level 27, Unit 2705, Marina Plaza, Dubai - United Arab Emirates",
  addressLines: ["Level 27, Unit 2705, Marina Plaza", "Dubai - United Arab Emirates"],
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Marina+Plaza+Dubai+Marina+Dubai+United+Arab+Emirates",
  whatsappDisplay: "+971 50 867 26 30",
  whatsappLink: "https://wa.me/971508672630",
  email: "info@moruya-ts.com",
  emailLink: "mailto:info@moruya-ts.com",
  hours: "Sunday – Friday, 09:00 – 19:00 (GST)",
};

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "services", label: "Activities" },
  { id: "platforms", label: "Platforms" },
  { id: "why", label: "Why Moruya" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact Us" },
];

export const SERVICES = [
  {
    key: "visa",
    icon: "FileCheck2",
    badge: "Group activity",
    title: "Online Visa Applications",
    summary:
      "Our group develops and holds online visa application platforms — the portals where travellers prepare and submit e-visa and visit-visa applications for supported destinations.",
    points: [
      "Application portals built and maintained at group level",
      "Destination and eligibility rules kept up to date",
      "Document checklists and submission workflows",
    ],
    accent: "teal",
  },
  {
    key: "insurance",
    icon: "ShieldCheck",
    badge: "Group activity",
    title: "Travel Insurance",
    summary:
      "Travel insurance distribution is arranged through licensed insurer and broker partners, integrated into the group's platforms so travellers can add cover alongside their application.",
    points: [
      "Policies underwritten by licensed insurer partners",
      "Cover formats commonly required for visa submissions",
      "Distribution handled by our operating brands",
    ],
    accent: "navy",
  },
  {
    key: "esim",
    icon: "Smartphone",
    badge: "Group activity",
    title: "Travel eSIM",
    summary:
      "Travel connectivity is the group's third activity: prepaid eSIM data plans supplied through connectivity partners and offered on our own eSIM platforms.",
    points: [
      "Country, regional and global data bundles",
      "QR-code activation flows built into our platforms",
      "Supplied via connectivity and roaming partners",
    ],
    accent: "orange",
  },
];

// ---------------------------------------------------------------------------
// GROUP PLATFORMS
// To publish a platform as a live link, fill in its `url`
// (e.g. "https://www.dubaivizehatti.com") and set `status` to "Live".
// The card then becomes clickable with a "Visit website" action and a Live badge.
// Leave `url` empty ("") while a platform is still being prepared.
// ---------------------------------------------------------------------------
export const TURKISH_EVISA_PLATFORMS = [
  {
    key: "evisa-tr-hatti",
    icon: "Languages",
    market: "Turkish \u00b7 Dubai e-visa",
    title: "Dubai Vize Hatt\u0131",
    domain: "www.dubaivizehatti.com",
    text:
      "Our first live portal: Turkish travellers check Dubai visa requirements and complete their online application start to finish.",
    status: "Live",
    url: "https://www.dubaivizehatti.com",
  },
  {
    key: "evisa-tr-vizecim",
    icon: "Languages",
    market: "Turkish \u00b7 Dubai e-visa",
    title: "Dubai Vizecim",
    domain: "www.dubaivizecim.com",
    text:
      "A second Turkish-language Dubai visa portal being prepared for launch alongside Dubai Vize Hatt\u0131.",
    status: "Coming soon",
    url: "",
  },
  {
    key: "evisa-tr-online",
    icon: "Languages",
    market: "Turkish \u00b7 Dubai e-visa",
    title: "Dubai Vize Online",
    domain: "www.dubaivizeonline.com",
    text:
      "Turkish-language Dubai visa portal in preparation, focused on fast fully online applications.",
    status: "Coming soon",
    url: "",
  },
  {
    key: "evisa-tr-kapisi",
    icon: "Languages",
    market: "Turkish \u00b7 Dubai e-visa",
    title: "Dubai Vize Kap\u0131s\u0131",
    domain: "www.dubaivizekapisi.com",
    text:
      "Turkish-language Dubai visa portal in preparation, built around a guided step-by-step application.",
    status: "Coming soon",
    url: "",
  },
  {
    key: "evisa-tr-uzmani",
    icon: "Languages",
    market: "Turkish \u00b7 Dubai e-visa",
    title: "Dubai Vize Uzman\u0131",
    domain: "www.dubaivizeuzmani.com",
    text:
      "Turkish-language Dubai visa portal in preparation, with an emphasis on document guidance and support.",
    status: "Coming soon",
    url: "",
  },
];

export const OTHER_PLATFORMS = [
  {
    key: "evisa-en",
    icon: "Globe",
    market: "English-language market",
    title: "E-visa application portal",
    domain: "",
    text:
      "An English-language platform where travellers check requirements and submit online visa applications for supported destinations.",
    status: "In development",
    url: "",
  },
  {
    key: "esim-platform",
    icon: "Smartphone",
    market: "English & Turkish",
    title: "Travel eSIM store",
    domain: "",
    text:
      "A direct-to-traveller eSIM platform offering prepaid data plans for 100+ destinations with instant QR activation.",
    status: "In development",
    url: "",
  },
  {
    key: "insurance-platform",
    icon: "ShieldCheck",
    market: "Partner-led",
    title: "Travel insurance distribution",
    domain: "",
    text:
      "Insurance cover offered alongside visa applications, underwritten and issued by our licensed insurer partners.",
    status: "Partner integration",
    url: "",
  },
];

export const PLATFORMS = [...TURKISH_EVISA_PLATFORMS, ...OTHER_PLATFORMS];

export const REASONS = [
  {
    icon: "Globe",
    title: "Built market by market",
    text:
      "Every portal is designed for one audience in its own language rather than a single translated storefront - starting with Turkish travellers heading to Dubai.",
  },
  {
    icon: "Handshake",
    title: "Delivered with licensed partners",
    text:
      "Insurers, connectivity suppliers and processing partners handle the regulated parts of each service under group agreements.",
  },
  {
    icon: "Layers",
    title: "Room to grow",
    text:
      "New portals, languages and destinations are added to the same group structure, so each launch builds on the technology and partnerships already in place.",
  },
];

export const STATS = [
  { value: "3", label: "Activities held by the group" },
  { value: "5", label: "Turkish Dubai visa portals" },
  { value: "Dubai", label: "Head office" },
  { value: "EN & TR", label: "Launch languages" },
];

export const FAQS = [
  {
    q: "Can I apply for a visa, buy insurance or get an eSIM on this website?",
    a: "No - this is the corporate website of the parent company. Applications take place on the group's own portals. For Turkish travellers Dubai Vize Hatt\u0131 (www.dubaivizehatti.com) is live today; the other portals become clickable in the Platforms section as each one launches.",
  },
  {
    q: "Which websites belong to the group?",
    a: "Our Turkish-language Dubai visa portals are dubaivizehatti.com (live), dubaivizecim.com, dubaivizeonline.com, dubaivizekapisi.com and dubaivizeuzmani.com. An English-language visa portal, a travel eSIM store and insurance distribution are in preparation.",
  },
  {
    q: "Is Moruya an insurer, a telecom operator or a government authority?",
    a: "No. Insurance products are underwritten and issued by licensed insurer partners, connectivity is supplied by licensed providers, and visa decisions are made solely by the relevant immigration authorities.",
  },
  {
    q: "I am an insurer, eSIM supplier, agency or technology provider - can we work together?",
    a: "Yes, that is what this site is for. Send a partnership enquiry with a short description of your business and where you see the fit, and the head office will come back to you.",
  },
  {
    q: "How can I reach the head office?",
    a: "Message +971 50 867 26 30 on WhatsApp, email info@moruya-ts.com, or use the enquiry form below. Corporate, investment, media and careers enquiries all reach the right person through the same form.",
  },
];

export const SERVICE_OPTIONS = [
  "Partnership / supplier",
  "Corporate & investment",
  "Media & press",
  "Careers",
  "General enquiry",
];

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1518684079-3c830dcef090?auto=format&fit=crop&w=1200&q=80",
  aerial:
    "https://images.unsplash.com/photo-1584546459262-0ddde08da490?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxEdWJhaSUyMG1hcmluYSUyMGFlcmlhbCUyMHZpZXd8ZW58MHx8fGJsdWV8MTc4OTEzMzAxMXww&ixlib=rb-4.1.0&q=85&w=1600",
  documents:
    "https://images.unsplash.com/photo-1523655408191-bf62e6aeead6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxwYXNzcG9ydCUyMHZpc2ElMjB0cmF2ZWwlMjBkb2N1bWVudHMlMjBmbGF0bGF5fGVufDB8fHxibHVlfDE3ODkxMzI5Nzh8MA&ixlib=rb-4.1.0&q=85&w=1000",
};
